import React from "react";
import OfferCard from "components/OfferCard";
import { useFormik } from "formik";
import { goToTop } from "helpers/helpers";
import NavigateButtons from "components/NavigateButtons";

export default function Step2({ currentStep, setCurrentStep, stepsState, persistState }) {
   console.log(window.dataLayer);
   const formik = useFormik({
      enableReinitialize: true,
      initialValues: stepsState,
      onSubmit: value => {
         //salvam codul ofertei selectate in state
         persistState(prevState => {
            return {
               ...prevState,
               step2: {
                  ...prevState.step2,
                  cod: value.cod,
               },
            };
         });
         goToTop();
         window.dataLayer.push({ event: "pas_2_casnici", info: { pagina: "step-2", finalizat: "da" } });
         setCurrentStep(currentStep + 1);
         localStorage.setItem("sessionCurrentStep", currentStep + 1);
      },
   });

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-12 ml-auto mr-auto">
                  <div className="pas-2">
                     <h2 className="first_title">Alege oferta potrivită pentru tine</h2>
                     <form onSubmit={formik.handleSubmit}>
                        {Array.isArray(stepsState.oferte) &&
                           stepsState.oferte.map((offer, index) => {
                              return <OfferCard key={index} offer={offer} selectOffer={formik.setFieldValue} />;
                           })}
                     </form>
                     <p className="color-gray2 text-center font-size-12">
                        Prețurile afișate mai sus se referă la preţul gazelor naturale (care include servicii de înmagazinare și echilibrare), iar
                        pentru prețul final se vor adăuga prețul transportului, tarifele reglementate de distribuție (care diferă în funcție de
                        operatorul de distribuție și de categoria consum), acciză și orice alte tarife și taxe ce vor fi introduse de autoritatea de
                        reglementare competentă, conform prevederilor legale în vigoare, fiind actualizat de drept și automat ori de câte ori
                        intervine o modificare a tarifelor reglementate.
                        <br />
                        Prețurile afișate nu conțin TVA. Condițiile ofertelor sunt completate de clauzele contractuale generale.
                     </p>
                     <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep} next={"displayNone"} />
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}
